import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalController, ToastController } from "@ionic/angular";
import { ApplicantStatusService } from "src/app/services/Applicant-Status.service";

@Component({
  selector: "appointment-approve-case",
  templateUrl: "./appointment-approve-case.component.html",
})
export class AppointmentApproveComponent implements OnInit {
  approveForm: FormGroup = new FormGroup({});
  appointmentId: string;
  addresses: string[] = []; // Array to store fetched addresses
  selectedAddresses: string[] = []; // Array to store selected addresses
  typedAddress: string = ''; // Variable to store typed address
  selectedAddress: string = ''; // Variable to store selected address

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private applicantStatusService: ApplicantStatusService
  ) {}

  ngOnInit(): void {
    this.approveForm = new FormGroup({
      authorityAdress: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(2000),
      ]),
    });
    console.log("hiiiiii fetchAddresses");

    this.fetchAddresses();
  }
  selectAddress(address: string) {
    this.selectedAddress = address;
  }
  
  
  async fetchAddresses() {
    try {
      console.log("hiiiiii adressss");
      console.log(this.appointmentId);

      this.applicantStatusService
      .findAddress()
        .subscribe(async (data: any) => {
          console.log(" data ", data);
          console.log("Fetched addresses:", data);
        this.addresses = data.map((item: any) => item.address); // Assuming the address is the property you want to display

        });
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  }

  toggleAddressSelection(address: string) {
    if (this.isSelected(address)) {
      // Deselect address if already selected
      this.selectedAddresses = this.selectedAddresses.filter(
        (selectedAddress) => selectedAddress !== address
      );
    } else {
      // Select address if not already selected
      this.selectedAddresses = [address]; // Replace the array with the selected address
    }
  }

  isSelected(address: string): boolean {
    return this.selectedAddresses.includes(address);
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  async approve() {
    if (!this.selectedAddress) {
      this.showErrorToast("Please select an address");
      return;
    }
  
    return this.modalCtrl.dismiss([this.selectedAddress], "approve");
  }
  


  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }
}
